module.exports = __webpack_public_path__ + "static/media/soup.0244f622.svg";